module.exports = __webpack_public_path__ + "img/clement-bed2-min.10e2ae87.png";